import UserHistoryService from "@/services/UserHistoryService";

function initialState() {
    return {
        userHistory: [],
    }
}

export default {
    state: initialState(),
    getters: {
        USER_HISTORY: state => state.userHistory,
    },
    mutations: {
        PUSH_USER_HISTORY(state, payload) {
            state.userHistory.unshift(payload);
        },
        SET_USER_HISTORY(state, payload) {
            state.userHistory = payload;
        },
        DELETE_LAST_USER_HISTORY(state) {
            state.userHistory.splice(state.userHistory.length - 1, 1);
        },
        DELETE_USER_HISTORY(state, payload) {
            state.userHistory.splice(payload, 1);
        }
    },
    actions: {
        ADD_USER_HISTORY: ({commit, getters}, payload) => {
            const indexOfDuplicateHistory = UserHistoryService.returnIndexOfDuplicateHistory(getters.USER_HISTORY, payload.code);

            if (indexOfDuplicateHistory >= 0) {
                commit('DELETE_USER_HISTORY', indexOfDuplicateHistory);
            }

            if (UserHistoryService.checkIsMoreThan15HistoryItems(getters.USER_HISTORY)) {
                commit('DELETE_LAST_USER_HISTORY');
            }

            commit('PUSH_USER_HISTORY', {...payload, tenant : getters.CURRENT_TENANT});

            UserHistoryService.setHistoryToLocalStorage(getters.USER_HISTORY);
        },
        UPDATE_USER_HISTORY: ({commit, getters}, payload) => {
            commit('SET_USER_HISTORY', payload);
            UserHistoryService.setHistoryToLocalStorage(getters.USER_HISTORY);
        },
    }
}
